import api from '../../plugins/api'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  actions: {
    async fetchItems({commit}, params = {}) {
      const items = await api.EnrollDeadline.fetch(params)
      commit('changeState', {items})
    },
    setDeadline(_, params = {}) {
      return api.EnrollDeadline.setDeadline(params)
    },
  },
  getters: {
    items: state => state.items,
  },
}
